import { Popover } from 'antd';
import { FaShareAlt, FaWhatsapp, FaFacebookF, FaTwitter, FaTelegramPlane, FaLink } from 'react-icons/fa';
import { notify } from './AppNotification';

/**
 * Professional share button — uses the native OS share sheet on mobile
 * (navigator.share) and falls back to a social-platform popover on desktop.
 *
 * Props:
 *  - title: text shown as the share message (falls back to page title)
 *  - url: link to share (defaults to the current page URL)
 */
const ShareButton = ({ title, url }) => {
    const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
    const shareTitle = title || (typeof document !== 'undefined' ? document.title : 'Motor');
    const supportsNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

    const copyLink = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            notify('Sucesso', 'Link copiado para a área de transferência!', 'success');
        }).catch(() => {
            notify('Erro', 'Não foi possível copiar o link', 'error');
        });
    };

    const triggerNativeShare = async () => {
        try {
            await navigator.share({ title: shareTitle, url: shareUrl });
        } catch (e) {
            // user closed the native share sheet — nothing to do
        }
    };

    const shareTargets = [
        {
            name: 'WhatsApp',
            icon: <FaWhatsapp />,
            className: 'share-icon-whatsapp',
            href: `https://wa.me/?text=${encodeURIComponent(shareTitle + ' ' + shareUrl)}`
        },
        {
            name: 'Facebook',
            icon: <FaFacebookF />,
            className: 'share-icon-facebook',
            href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
        },
        {
            name: 'Twitter',
            icon: <FaTwitter />,
            className: 'share-icon-twitter',
            href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`
        },
        {
            name: 'Telegram',
            icon: <FaTelegramPlane />,
            className: 'share-icon-telegram',
            href: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`
        }
    ];

    const popoverContent = (
        <div className="share-popover-content">
            {shareTargets.map((target) => (
                <a
                    key={target.name}
                    href={target.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`share-icon-btn ${target.className}`}
                    title={`Compartilhar no ${target.name}`}
                >
                    {target.icon}
                </a>
            ))}
            <button
                type="button"
                className="share-icon-btn share-icon-copy"
                onClick={copyLink}
                title="Copiar link"
            >
                <FaLink />
            </button>
        </div>
    );

    if (supportsNativeShare) {
        return (
            <button type="button" className="share-main-btn" onClick={triggerNativeShare}>
                <FaShareAlt /> <span>Compartilhar</span>
            </button>
        );
    }

    return (
        <Popover
            content={popoverContent}
            title="Compartilhar anúncio"
            trigger="click"
            placement="bottomRight"
            overlayClassName="share-popover"
        >
            <button type="button" className="share-main-btn">
                <FaShareAlt /> <span>Compartilhar</span>
            </button>
        </Popover>
    );
};

export default ShareButton;